<template>
	<div class="bg-dark min-vh-100">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-5 col-md-7">
					<div class="msn-logo">
						<img src="https://msn.cdnbet.co/logo.png" />
					</div>
					<div class="card bg-secondary border-0">
						<div class="card-body">
							<form @submit.prevent="submitLogin">
								<base-input
									name="username"
									label="ชื่อผู้ใช้งาน"
									placeholder="ชื่อผู้ใช้งาน"
									required
									v-model="username"
								/>
								<base-input
									type="password"
									name="password"
									label="รหัสผ่าน"
									placeholder="รหัสผ่าน"
									required
									v-model="password"
								/>
								<base-input
									name="prefix"
									label="Prefix"
									placeholder="Prefix"
									required
									v-model="prefix"
								/>

								<base-input
									name="otpCode"
									label="OTP Code"
									placeholder="OTP Code"
									required
									v-model="otpCode"
									v-if="showOTP"
								/>

								<div class="text-center">
									<base-button
										native-type="submit"
										type="default"
										icon
										:disabled="loading"
									>
										<span class="btn-inner--icon">
											<i class="fas fa-sign-in-alt" />
										</span>
										<span class="btn-inner--text">เข้าสู่ระบบ</span>
									</base-button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import authService from '../services/auth.service'

export default {
	data() {
		return {
			loading: false,

			username: '',
			password: '',
			prefix: localStorage.getItem('prefix') || '',

			showOTP: '',
			otpCode: '',
		}
	},
	methods: {
		async submitLogin() {
			this.loading = true
			this.prefix = this.prefix.trim().toUpperCase()

			try {
				localStorage.setItem('x-prefix', this.prefix)
				await authService.login({
					username: this.username,
					password: this.password,
					prefix: this.prefix,
					otpCode: this.otpCode,
				})

				localStorage.setItem('prefix', this.prefix)

				this.$emit('fetchAuthInfo')
				this.$router.push('/dashboard/members')
			} catch ({ error, message }) {
				if (error === 'otp_required') {
					this.showOTP = true
					this.$notify({
						type: 'info',
						message: 'กรุณากรอก OTP Code เพื่อเข้าสู่ระบบ',
					})
				} else {
					this.$notify({ type: 'danger', message: message })
				}
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.msn-logo {
	text-align: center;
	padding: 10rem 0 2rem 0;
}

@media screen and (max-width: 720px) {
	.msn-logo {
		padding: 5rem 0 2rem 0;
	}
}
</style>
